import type { FunctionComponent, PropsWithChildren } from 'react';
import type { VideoFragment } from '../../graphql/fragments/SectionOfThumbnailsFragment.graphql';
import { asVideoType } from '../../types/video';
import { Video } from '../video';
import styles from './video-content.module.scss';
export const VideoContent: FunctionComponent<PropsWithChildren<Props>> = props => {
  const videoProps = asVideoType(props);
  if (!videoProps) {
    return null;
  }
  return <div className={styles['video-content']} data-sentry-component="VideoContent" data-sentry-source-file="index.tsx">
            <Video {...videoProps} data-sentry-element="Video" data-sentry-source-file="index.tsx" />
        </div>;
};
type Props = VideoFragment;